/* eslint-disable */
import { Inject } from '@angular/core';
import { Router } from '@angular/router';
import { DevstroupeNavigationItem } from '@devstroupe/components/navigation';
import { UserModel } from 'app/models/user.model';

// const IS_NOT_ADMIN = (item: HiddenOptions) => {
//     return item?.user?.profile_type !== 'ADMIN';
// };
// const IS_NOT_USER = (item: HiddenOptions) => {
//     return item?.user?.type !== 'USER';
// };

// criação de funções para ocultar os itens do menu sando a screens
// export const HIDE_IF_SCREEN = (item: HiddenOptions, screen: string) => {
//     return !item?.user;
// };

// //hide if function
// export const HIDE_IF_FUNCTION = (item: HiddenOptions, function_name: string) => {
//     return Boolean(item?.user?.role?.[function_name]);
// };

export interface HiddenOptions {
    user?: UserModel;
}

// const profilesMenus: DevstroupeNavigationItem[] = profilesTypes
//     .filter((e) => e != 'PATIENT')
//     .map((type) => {
//         return {
//             id: 'p.users',
//             title: `${profileTypeStrategies[type]}`,
//             type: 'basic',
//             icon: 'heroicons_outline:user-circle',
//             link: `/configuration/access/${profileTypeStrategies[type].toLowerCase()}`,
//             hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
//         };
//     });

const IS_NOT_ADMIN = (item: HiddenOptions) => {
    return !item?.user?.isAdmin;
};

export const classicNavigation: DevstroupeNavigationItem[] = [
    {
        id: 'p.wallet',
        title: 'Carteira',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:wallet', // Carteira
        link: '/wallet',
        hidden: (item: HiddenOptions) => !item?.user?.permission?.can_access_wallet,
    },
    {
        id: 'p.productions',
        title: 'Produções',
        subtitle: '',
        icon: 'heroicons_outline:document-check', // Produções
        type: 'basic',
        link: '/productions',
    },
    {
        id: 'p.crm',
        title: 'CRM',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:funnel',
        link: '/crm',
    },
    {
        id: 'p.sales',
        title: 'Vendas e Orçamentos',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:receipt-percent', // Vendas e Orçamentos
        link: '/sales',
        hidden: (item: HiddenOptions) => !item?.user?.permission?.can_access_sale,
    },
    {
        id: 'p.finance',
        title: 'Financeiro',
        subtitle: '',
        type: 'collapsable',
        icon: 'heroicons_outline:currency-dollar', // Financeiro
        hidden: (item: HiddenOptions) => !item?.user?.permission?.can_access_finance,
        children: [
            {
                id: 'p.finance.sales',
                title: 'Vendas',
                type: 'basic',
                icon: 'heroicons_outline:receipt-percent', // Vendas
                link: '/finance',
                exactMatch: true,
                hidden: (item: HiddenOptions) => !item?.user?.permission?.can_access_finance,
            },
            {
                id: 'p.finance.others',
                title: 'Outros',
                type: 'basic',
                icon: 'heroicons_outline:ellipsis-horizontal-circle', // Outros
                link: '/finance/outros',
                hidden: (item: HiddenOptions) => !item?.user?.permission?.can_access_finance,
            },
        ],
    },
    {
        id: 'p.nfe',
        title: 'Notas Fiscais',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:document-text', // Nota Fiscal
        link: '/nfe',
        hidden: (item: HiddenOptions) => !item?.user?.isAdmin && !item?.user?.permission?.can_access_nfe,
    },
    {
        id: 'p.cliensts',
        title: 'Clientes',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:user-group', // Clientes
        link: '/clients',
        hidden: (item: HiddenOptions) =>
            !item?.user?.permission?.can_access_clients &&
            !item?.user?.permission?.view_clients_wallet_or_own_confirmed_sales,
    },
    {
        id: 'p.carriers',
        title: 'Transportadoras',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:truck',
        link: '/carriers',
        hidden: (item: HiddenOptions) =>
            !item?.user?.isAdmin && !item?.user?.permission?.can_access_carriers,
    },
    {
        id: 'p.suppliers',
        title: 'Fornecedores',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:building-storefront',
        link: '/suppliers',
        hidden: (item: HiddenOptions) =>
            !item?.user?.isAdmin && !item?.user?.permission?.can_access_suppliers,
    },
    {
        id: 'p.products',
        title: 'Produtos',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:cube',
        link: '/products',
        hidden: (item: HiddenOptions) => !item?.user?.permission?.can_access_products,
    },
    {
        id: 'p.users',
        title: 'Usuários',
        subtitle: '',
        type: 'basic',
        icon: 'heroicons_outline:user', // Usuários
        link: '/users',
        hidden: (item: HiddenOptions) => !item?.user?.isAdmin && !item?.user?.permission?.can_access_users,
    },
    {
        id: 'p.reports',
        title: 'Relatórios',
        subtitle: '',
        type: 'collapsable',
        icon: 'heroicons_outline:chart-bar',
        hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
        children: [
            {
                id: 'p.reports.seller_ranking',
                title: 'Ranking de Vendedores',
                type: 'basic',
                icon: 'heroicons_outline:trophy',
                link: '/reports/seller-ranking',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
            {
                id: 'p.reports.seller_revenue',
                title: 'Faturamento por Vendedor',
                type: 'basic',
                icon: 'heroicons_outline:chart-bar-square',
                link: '/reports/seller-revenue',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
        ],
    },
    {
        id: 'p.configurations',
        title: 'Configurações',
        subtitle: '',
        type: 'collapsable',
        icon: 'heroicons_outline:cog-8-tooth', // Configurações
        hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
        children: [
            {
                id: 'p.roles',
                title: 'Funções',
                type: 'basic',
                icon: 'heroicons_outline:shield-check', // Funções
                link: '/configuration/permissons',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
            {
                id: 'p.product',
                title: 'Produtos',
                type: 'basic',
                icon: 'heroicons_outline:cube', // Produtos
                link: '/configuration/products',
                hidden: () => true,
            },
            {
                id: 'p.product_types',
                title: 'Tipos de Produtos',
                type: 'basic',
                icon: 'heroicons_outline:tag', // Tipos de Produtos
                link: '/configuration/type_product',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
            {
                id: 'p.status_order',
                title: 'Status de Ordem de Produção',
                type: 'basic',
                icon: 'heroicons_outline:clipboard-document-list', // Status de Ordem de Produção
                link: '/configuration/status-order',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
            {
                id: 'p.companies',
                title: 'Empresas',
                type: 'basic',
                icon: 'heroicons_outline:building-office', // Empresas
                link: '/configuration/companies',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
            {
                id: 'p.financial_account',
                title: 'Contas Financeiras',
                type: 'basic',
                icon: 'heroicons_outline:banknotes', // Contas Financeiras
                link: '/configuration/financial-account',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
            {
                id: 'p.integrations',
                title: 'Integrações',
                type: 'basic',
                icon: 'heroicons_outline:puzzle-piece', // Integrações (WhatsApp)
                link: '/configuration/integrations',
                hidden: (item: HiddenOptions) => IS_NOT_ADMIN(item),
            },
        ],
    },
];

export const compactNavigation: DevstroupeNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: DevstroupeNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: DevstroupeNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
